import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import SaleOrderService from "../../Controller/SaleOrderController";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import { handleChange, handleSubmit } from "../../Controller/UpdateBillingController";
import HelpSite from "../../../Common/HelpLink";
function SaleOrderBillingAddress({ SaleOrderID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [CountryList, setCountries] = useState([]);
    const [formData, setFormData] = useState({
        vc_Title: "",
        vc_Address1: "",
        vc_Address2: "",
        vc_Address3: "",
        vc_Town: "",
        vc_County: "",
        vc_Country: "",
        vc_Telephone: "",
        vc_FullName: ""
    });
    const { theme } = useContext(ThemeContext);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [isClosed, SetIsClosed] = useState("0");
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        SetIsClosed("0");
        fetchCountries();
        if (SaleOrderID > 0) {
            fetchSaleOrderDetail();
        }
        else {
            resetForm();
        }
    }, [SaleOrderID]);
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchSaleOrderDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (SaleOrderID > 0) {
                const saleOrderDetail = await SaleOrderService.GetSaleOrderByID(redirectCallback, SaleOrderID);
                const saleOrder = saleOrderDetail[0];
                if (saleOrder.bit_DropShipment > 0 || saleOrder.bit_DropShipmentc > 0) {
                    SetIsClosed("1");
                }
                setFormData({
                    ...saleOrder,
                });
            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/SaleOrderList?saved=true');
            };
            const message = await handleSubmit(event, formData, setFormData, setErrors);
            if (message == "Data saved successfully") {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }
            else {
                setShowErrorMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowErrorMessage(false);
                }, 5000);

            }
            fetchSaleOrderDetail();
        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };
    const resetForm = () => {

        setFormData({
            vc_Title: "",
            vc_Address1: "",
            vc_Address2: "",
            vc_Address3: "",
            vc_Town: "",
            vc_County: "",
            vc_Country: "",
            vc_Telephone: "",
            vc_FullName: ""
        });
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {showSuccessMessage && (
                <div class="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                    Data saved successfully.
                </div>
            )}
            {showErrorMessage && (
                <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                    Validation Error.

                </div>
            )}
            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginRight: "5px", marginTop: "10px" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td style={{width:"13%"}}><label htmlFor="vc_FullName" style={{ float: "right" }}>Title <span style={{ "color": "red" }}>*</span></label></td>
                                <td style={{width:"37%"}}>
                                    <input type="text" className="form-control" name="vc_FullName" value={formData.vc_FullName} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_FullName && <div style={{ color: 'red' }}>{errors.vc_FullName}</div>}
                                </td>
                                <td style={{width:"13%"}}></td>
                                <td style={{width:"37%"}}></td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address1" style={{ float: "right" }}>Address <span style={{ "color": "red" }}>*</span></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_Address1" value={formData.vc_Address1} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_Address1 && <div style={{ color: 'red' }}>{errors.vc_Address1}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address2" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_Address2" value={formData.vc_Address2} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_Address2 && <div style={{ color: 'red' }}>{errors.vc_Address2}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_Address3" style={{ float: "right" }}></label></td>
                                <td colSpan={3}>
                                    <input type="text" className="form-control" name="vc_Address3" value={formData.vc_Address3} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_Address3 && <div style={{ color: 'red' }}>{errors.vc_Address3}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="Town" style={{ float: "right" }}>Town &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Town" value={formData.vc_Town} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_Town && <div style={{ color: 'red' }}>{errors.vc_Town}</div>}
                                </td>
                                <td><label htmlFor="County" style={{ float: "right" }}>County &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_County" value={formData.vc_County} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_County && <div style={{ color: 'red' }}>{errors.vc_County}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_PostCode" style={{ float: "right" }}>Post Code &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_PostCode" value={formData.vc_PostCode} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_PostCode && <div style={{ color: 'red' }}>{errors.vc_PostCode}</div>}
                                </td>
                                <td><label htmlFor="Telephone" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="vc_Telephone" value={formData.vc_Telephone} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1} />
                                    {errors.vc_Telephone && <div style={{ color: 'red' }}>{errors.vc_Telephone}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="vc_PostCode" style={{ float: "right" }}>Country &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="vc_Country" className='form-control' value={formData.vc_Country} onChange={handleFieldChange} disabled={isClosed === '1' || isClosed === 1}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.vc_Country && <div style={{ color: 'red' }}>{errors.vc_Country}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td colSpan={3}></td>
                                <td style={{float:"right"}}>
                                    <button type="submit" className="btn btn-primary" disabled={isClosed === '1' || isClosed === 1 || localStorage.getItem('LicenseExpired') == "1"}>
                                       <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> Save

                                    </button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </form>


        </div>


    );
}
export default SaleOrderBillingAddress;

